"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/styles");

var _core = require("@material-ui/core");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    marginBottom: {
      marginBottom: 20
    },
    formLabel: {
      fontSize: 12,
      marginTop: 3
    },
    colorPicker: {
      width: "100%",
      marginTop: ".2rem",
      marginBottom: "1rem"
    }
  };
});

var AttributesCheckbox = function AttributesCheckbox(_ref) {
  var objectsForm = _ref.objectsForm,
      properties = _ref.properties,
      handleItemAttribute = _ref.handleItemAttribute,
      handlePropertyChange = _ref.handlePropertyChange,
      accordionFilter = _ref.accordionFilter;
  var classes = useStyles();
  var attributes = properties.attributes;

  var handleChangeDefault = function handleChangeDefault(e, i) {
    handleItemAttribute(properties, "value", e.target.checked, i);
  };

  var handleSelectAccordion = function handleSelectAccordion(e) {
    return handlePropertyChange(properties, "childAccordion", e.target.value);
  };

  return /*#__PURE__*/React.createElement("form", null, accordionFilter(objectsForm).length > 0 && /*#__PURE__*/React.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Define a que acordeon pertenece",
    "aria-label": "value",
    placement: "top"
  }, /*#__PURE__*/React.createElement(_core.FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(_core.FormLabel, {
    component: "label",
    className: classes.formLabel
  }, "Definir a que acordeon pertenece"), /*#__PURE__*/React.createElement(_core.RadioGroup, {
    "aria-label": "childAccordion",
    name: "childAccordion",
    value: properties.childAccordion,
    onChange: handleSelectAccordion
  }, accordionFilter(objectsForm).filter(function (res) {
    return res.i !== "step-0";
  }).map(function (acc, key) {
    return /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      key: key,
      value: acc.i,
      control: /*#__PURE__*/React.createElement(_core.Radio, {
        color: "primary"
      }),
      label: acc.label
    });
  })), /*#__PURE__*/React.createElement(_core.Button, {
    disabled: !properties.childAccordion,
    size: "small",
    onClick: function onClick(e) {
      e.preventDefault();
      handlePropertyChange(properties, "childAccordion", null);
    }
  }, "Reset accordion")))), /*#__PURE__*/React.createElement(_core.Tooltip, {
    title: "Define si el campo es requerido",
    "aria-label": "required",
    placement: "left-start",
    className: classes.marginBottom
  }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "required",
      color: "primary",
      checked: properties.required,
      onChange: function onChange(e, checked) {
        handleItemAttribute(properties, "required", checked);
      }
    }),
    label: "Requerido"
  })), /*#__PURE__*/React.createElement(_core.FormControl, null, /*#__PURE__*/React.createElement(_core.InputLabel, null, "Cantidad de elementos"), /*#__PURE__*/React.createElement(_core.Select, {
    name: "count",
    value: properties.count,
    style: {
      width: "100%"
    },
    onChange: function onChange(e) {
      handleItemAttribute(properties, "count", e.target.value);
    },
    className: classes.marginBottom
  }, Array.from(new Array(4)).map(function (_, i) {
    return /*#__PURE__*/React.createElement(_core.MenuItem, {
      key: i,
      value: i + 1
    }, i + 1);
  })), attributes.map(function (atr, i) {
    return /*#__PURE__*/React.createElement(_core.Grid, {
      container: true,
      spacing: 1,
      key: i,
      style: {
        marginBottom: 10
      }
    }, /*#__PURE__*/React.createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 11
    }, /*#__PURE__*/React.createElement(_core.Tooltip, {
      title: "Define el nombre del elemento",
      "aria-label": "labelInside",
      placement: "left-start"
    }, /*#__PURE__*/React.createElement(_core.TextField, {
      label: "Nombre",
      value: atr.labelInside,
      placeholder: "Nombre Etiqueta",
      onChange: function onChange(e) {
        handleItemAttribute(properties, "labelInside", e.target.value, i);
      }
    }))), /*#__PURE__*/React.createElement(_core.Grid, {
      item: true,
      xs: 12,
      sm: 1
    }, /*#__PURE__*/React.createElement(_core.Tooltip, {
      title: "Definir check por defecto",
      "aria-label": "value",
      placement: "top"
    }, /*#__PURE__*/React.createElement(_core.FormGroup, {
      row: true,
      style: {
        marginTop: 18
      }
    }, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
      control: /*#__PURE__*/React.createElement(_core.Checkbox, {
        color: "primary",
        checked: atr.value,
        onChange: function onChange(e) {
          return handleChangeDefault(e, i);
        }
      })
    })))));
  })));
};

var _default = AttributesCheckbox;
exports.default = _default;